import React from 'react';
import { NavLink } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import { FiBook, FiInfo, FiEdit3, FiDatabase, FiTerminal, FiBarChart2, FiFileText, FiShare2, FiCheckSquare } from 'react-icons/fi';

const navItems = [
  { path: '/', label: 'Introduction & Why', icon: FiBook },
  { path: '/evidence', label: 'The Evidence Base', icon: FiBarChart2 },
  { path: '/terminology', label: 'Terminology Guide', icon: FiInfo },
  { path: '/design', label: '1. Design & Planning', icon: FiEdit3 },
  { path: '/data', label: '2. Data & Management', icon: FiDatabase },
  { path: '/analysis', label: '3. Analysis & Code', icon: FiTerminal },
  { path: '/reporting', label: '4. Reporting & Transparency', icon: FiFileText },
  { path: '/sharing', label: '5. Sharing & Archiving', icon: FiShare2 },
  { path: '/getting-started', label: 'Getting Started', icon: FiCheckSquare },
];

const Sidebar = ({ onClose }) => {
  return (
    <div className="h-full flex flex-col py-6">
      <div className="px-6 mb-8 hidden md:block">
        <h1 className="font-serif font-bold text-xl text-slate-900 leading-tight">
          The Reproducible<br/>Scientist
        </h1>
        <p className="text-sm text-brand-700 mt-2 font-medium">A guide for scientists</p>
      </div>

      <nav className="flex-1 px-4 space-y-1">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            onClick={onClose}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-medium transition-colors ${
                isActive
                  ? 'bg-brand-100 text-brand-900'
                  : 'text-slate-600 hover:bg-slate-200 hover:text-slate-900'
              }`
            }
          >
            <SafeIcon icon={item.icon} className="w-4 h-4 flex-shrink-0" />
            {item.label}
          </NavLink>
        ))}
      </nav>

      <div className="px-6 mt-auto pt-6 border-t border-slate-200">
        <p className="text-xs text-slate-500 text-center">
          Building a better foundation for the future of research.
        </p>
        <p className="text-xs text-slate-400 text-center mt-3">
          Sponsored by{' '}
          <a
            href="https://digitalspecies.io"
            target="_blank"
            rel="noopener noreferrer"
            className="font-medium text-brand-600 hover:text-brand-800"
          >
            Digital Species
          </a>
        </p>
      </div>
    </div>
  );
};

export default Sidebar;